import React, { useState } from 'react';
import { Button } from '@mui/material';
import { useTranslation } from 'react-i18next';

export default function FileUploader({ label, onChange, attachedFile, error }) {
    const [file, setFile] = useState(null);
    const { t } = useTranslation();

    const handleFileChange = (event) => {
        const selectedFile = event.target.files[0];
        setFile(selectedFile);
        onChange(selectedFile);
    };



    return (
        <div className="mb-3">
            <div className="d-flex flex-column align-items-center justify-content-center">
                <input
                    type="file"
                    accept=".pdf"
                    id={`file-input-${label}`}
                    style={{ display: 'none' }}
                    onChange={handleFileChange}
                />
                <Button
                    variant='contained'
                    color={error ? "error" : 'primary'}
                    onClick={() => document.getElementById(`file-input-${label}`).click()}
                >
                    {label}
                </Button>
                {file && (
                    <div className="text-muted">
                        <strong>{t("user.fileSelected")}:</strong> {file.name} - {Math.round(file.size / 1024)} KB
                    </div>
                )}
                {attachedFile && typeof (attachedFile) == "string" && (
                    <div className="mt-2">
                        <Button
                            variant="contained"
                            sx={{
                                backgroundColor: "#ca8d42",
                                "&:hover": {
                                    backgroundColor: "#b07b39",
                                    color:"#fff"
                                },
                            }}
                            href={attachedFile}
                            target="_blank"
                        >
                            {t("user.viewFile")}
                        </Button>
                    </div>
                )}
            </div>
        </div>
    );
}
